module.exports = {
      id: "c64b0e36a65937d18b51328b6cb5afb9sewerage-drain.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#c64b0e36a65937d18b51328b6cb5afb9sewerage-drain.svg",
      toString: function () {
        return this.url;
      }
    }